import { useEffect, useState } from "react"

const DESKTOP_BREAKPOINT = 1024
const MINI_MOBILE_SCREEN_HEIGHT = 720
const MINI_MOBILE_SCREEN_WIDTH = 390

export const useWindowSize = () => {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState<{
    width: number
    height: number
    isDesktop: boolean
    isMiniMobileScreen: boolean
  }>({
    height: 0,
    isDesktop: false,
    isMiniMobileScreen: false,
    width: 0,
  })
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        height: window.innerHeight,
        isDesktop: window.innerWidth > DESKTOP_BREAKPOINT,
        isMiniMobileScreen:
          window.innerHeight < MINI_MOBILE_SCREEN_HEIGHT ||
          window.innerWidth < MINI_MOBILE_SCREEN_WIDTH,
        width: window.innerWidth,
      })
    }
    // Add event listener
    window.addEventListener("resize", handleResize)
    // Call handler right away so state gets updated with initial window size
    handleResize()
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize)
  }, []) // Empty array ensures that effect is only run on mount
  return windowSize
}
